// app/(app)/_layout.tsx
import CustomDrawerContent from "@/components/default/CustomDrawerContent";
import { useAppTheme } from "@/hooks/useAppTheme";
import { Drawer } from "expo-router/drawer";

export default function AppLayout() {
  const { colors } = useAppTheme();

  return (
    <Drawer
      drawerContent={(props) => <CustomDrawerContent {...props} />}
      screenOptions={{
        headerStyle: { backgroundColor: colors.background },
        headerTintColor: colors.text,
        headerShadowVisible: false,
        drawerStyle: { backgroundColor: colors.background, width: 280 },
        drawerActiveTintColor: colors.primary,
        drawerInactiveTintColor: colors.textLight,
        drawerContentStyle: { backgroundColor: colors.background },
      }}
    >
      <Drawer.Screen name="dashboard" options={{ title: "Dashboard" }} />
      <Drawer.Screen
        name="dashboard/activities"
        options={{ title: "Activities" }}
      />
      <Drawer.Screen name="employees" options={{ title: "Employees" }} />
      <Drawer.Screen name="employees/add" options={{ title: "Employees" }} />
      <Drawer.Screen name="employees/[id]" options={{ title: "Employees" }} />
      <Drawer.Screen name="customers" options={{ title: "Customers" }} />
      <Drawer.Screen name="customers/add" options={{ title: "Customers" }} />
      <Drawer.Screen name="customers/[id]" options={{ title: "Customers" }} />
      <Drawer.Screen name="invoices" options={{ title: "Invoices" }} />
      <Drawer.Screen name="invoices/add" options={{ title: "Bill" }} />
      <Drawer.Screen
        name="invoices/[id]"
        options={{ title: "Invoices Details" }}
      />
      <Drawer.Screen
        name="invoices/edit/[id]"
        options={{ title: "Edit Invoices" }}
      />
      <Drawer.Screen name="reports" options={{ title: "Reports" }} />
      <Drawer.Screen name="settings" options={{ title: "Settings" }} />
      <Drawer.Screen name="inventory" options={{ title: "Inventory" }} />
      <Drawer.Screen name="payments" options={{ title: "Payments" }} />
      <Drawer.Screen name="payments/add" options={{ title: "Payments" }} />
      <Drawer.Screen
        name="payments/[id]"
        options={{ title: "Payments Details" }}
      />
    </Drawer>
  );
}
